import { render } from "./TitleScreen.vue?vue&type=template&id=9d6411c4"
import script from "./TitleScreen.vue?vue&type=script&lang=js"
export * from "./TitleScreen.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__